export const sanitizeForURL = (inputString) => {
  if (!inputString) {
    return '';
  }

  // Replace spaces with hyphens
  let modifiedString = inputString.replace(/ /g, '-');

  // Remove special characters
  modifiedString = modifiedString.replace(/[^\w-]/g, '');

  return modifiedString;
};

  export const sanitizedValue = (inputString) => {
    // Replace spaces with hyphens
    let modifiedString = inputString.replace(/ /g, '-');
  
    // Remove special characters (except hyphens)
    modifiedString = modifiedString.replace(/[^\w-]/g, '');
  
    // Convert to number
    const numericValue = Number(modifiedString);
  
    return numericValue;
  };

  export const formatPhoneNumber = (phoneNumber?: string | null): string => {
    if (!phoneNumber) return ''; // Return empty string if phoneNumber is undefined or null
  
    // Remove non-numeric characters from phoneNumber using a regular expression
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
  
    // Format the cleaned number as (XXX) XXX-XXXX
    return `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6)}`;
  };
  
  